import React from "react";
import { toSlug } from "../lib/formatters";

type ProductTypeOption = { id: string; label: string };

interface Props {
  value: string;
  onChange: (value: string) => void;
  productTypeExists: boolean;
  ensureProductTypeInDb: (id: string, label: string) => Promise<void>;
  setRpTypeOpts: React.Dispatch<React.SetStateAction<ProductTypeOption[]>>;
  onCreated: (option: ProductTypeOption) => void;
  setRpTypesPrimed: (primed: boolean) => void;
  showExistsWarning?: boolean;
  inputPlaceholder?: string;
  buttonClassName?: string;
}

/**
 * Inline add-new control for product types, shared between wizard and snabbinmatning.
 */
export default function ProductTypeCreateInline({
  value,
  onChange,
  productTypeExists,
  ensureProductTypeInDb,
  setRpTypeOpts,
  onCreated,
  setRpTypesPrimed,
  showExistsWarning = false,
  inputPlaceholder = "Ny produkttyp",
  buttonClassName = "btn btn-secondary",
}: Props): JSX.Element {
  const handleAdd = async () => {
    const name = value.trim();
    if (!name || productTypeExists) return;
    try {
      const id = toSlug(name);
      await ensureProductTypeInDb(id, name);
      setRpTypeOpts((prev) => {
        const list = Array.isArray(prev) ? prev : [];
        return list.some((o) => o.id === id)
          ? list
          : [...list, { id, label: name }].sort((a, b) =>
            a.label.localeCompare(b.label, "sv")
          );
      });
      onCreated({ id, label: name });
      setRpTypesPrimed(false); // prime:a om impact-cache vid behov
    } catch (err) {
      console.warn("Kunde inte skapa produkttyp:", err);
      alert("Kunde inte skapa produkttyp. Se konsolen för detaljer.");
    }
  };

  return (
    <>
      <input
        type="text"
        placeholder={inputPlaceholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        className="gw-input"
      />
      {showExistsWarning && productTypeExists && (
        <div style={{ color: "#b91c1c", fontSize: 13 }}>Produkttypen finns redan.</div>
      )}
      <button
        type="button"
        onClick={handleAdd}
        disabled={!value.trim() || !!productTypeExists}
        title={productTypeExists ? "Dublett: kan inte spara" : "Lägg till"}
        className={buttonClassName}
      >
        Lägg till
      </button>
    </>
  );
}
